/** Display label for a user/recipient profile (Firestore user doc shape). */
export function getDisplayName(profile) {
  return profile?.displayName || profile?.name || profile?.email || 'Usuário';
}
